export default __webpack_public_path__ + "media/12345678.07693791.png";